<template>
 <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-5 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="onSendLogin">
                <card type="login">
                  <div class="logo" slot="header"><span class="admin">admin</span><span class="traveller">Traveller</span></div>
   
                  <h6 class="card-subtitle text-center">{{ $t('login_view.login') }}</h6>
   
                  <!--
                  <fg-input v-model="form.username" addon-left-icon="nc-icon nc-single-02" :placeholder="$t('login_view.username_field')" :disabled='disabled'></fg-input>
                  <fg-input v-model="form.password" addon-left-icon="nc-icon nc-lock-circle-open" :placeholder="$t('login_view.password_field')" type="password" :disabled='disabled'></fg-input>
                  -->
                  
                  <fg-input v-model="form.username" addon-left-icon="b-icon bi-person-fill" :placeholder="$t('login_view.username_field')" :disabled='disabled'></fg-input>
                  <fg-input v-model="form.password" addon-left-icon="b-icon bi-unlock2-fill" :placeholder="$t('login_view.password_field')" type="password" :disabled='disabled'></fg-input>

                  <transition name="fade">
                    <div class="alert alert-danger" v-if="showError"><i class="nc-icon nc-alert-circle-i"></i>{{ errorMsg }}</div>
                  </transition>
                  
                  <p-button id="login_submit_btn" native-type="submit" block class="mb-3" :disabled='disabled'>{{ $t('login_view.login_button') }}</p-button>

                  <div id="content-loader" :style="{visibility: loader ? 'visible' : 'hidden'}"></div>

                  <div class="text-center" slot="footer"><i class="nc-icon nc-email-85"></i><a href="mailto:support.fin@trapezegroup.com">support.fin@trapezegroup.com</a></div>
                </card>
              </form>
            </div>
          </div>
        </div>
        <div class="full-page-background"></div>
      </div>
    </div>
  </div>

</template>

<script>

// @ is an alias to /src
import axios from 'axios'

import i18n from '../i18n'

export default {
  name: 'login',
  props: {
    modal: { type:Boolean, default: false }
  },
  components: {
  },
  data: function() {
        return {
        form: {
          username: '',
          password: '',
        },
        showError: false,
        errorMsg: null,
        loader: false,
        disabled: true,
        defaultViews: [
          '/system/overview',
          '/map/mapview',
          '/content/timetables',
          '/timetables/stops',
          '/timetables/lines',
          '/timetables/routes',
          '/timetables/seasons',
          '/realtime/vehicles',
          '/realtime/vehiclereport'
        ]
      }
  },
  beforeCreate(){
  
    // force always one reload on login page
    var key = 'TRAVELLER_RELOAD';
    var reload = localStorage.getItem(key);
    if(reload){
      localStorage.removeItem(key);
      location = location.pathname;    
    }
    else {
      localStorage.setItem(key, 1);
    }
     
    // fi-FI -> fi_FI
    if(navigator.language)
      i18n.locale = navigator.language.replace("-","_");
  },
  mounted(){
    this.disabled = false;
  },
  methods: {
    onSendLogin () {

        this.showError = false;
        this.loader = true;
      /*
        Täällä tehtään kirjautuminen Travellerille. Vastaus on joko onnistunut kirjaus jonka mukana tulee
        JWT Auth token tai sitten virheitilanteen ilmoittava vastaus.
        Jos vastaus oli ok ja saatiin auth token niin tallennetaan se Vuexiin jolloin sitä voidaan
        käyttää sovelluksessa.
        Huom. Tässä käytetään normaalia Axiosta eikä traveller_axiosta koska meillä ei ole nyt validia tokenia
        joten sitä ei voi välittää pyynnön mukana, uuttahan tässä ollaan vailla kun kirjautumisesta on kyse.
      */
      
      const vm = this;
      var formString = JSON.stringify(this.form);
      axios.post('/traveller/restui/authenticateUser', "authData="+formString)
           .then(function(resp) {
              setTimeout(function(){
       
                vm.loader = false;
                if(resp.data.code !== undefined ) {
                  vm.showError = true;
                  vm.errorMsg = resp.data.message;
                  // TODO Kirjoita kielituettu virheilmoitus
                  //console.log(resp.data.errorMessage);
                }

                if (resp.data.authToken !== undefined) {
                  var userData = resp.data;
                  vm.$store.commit('login', userData);
                  vm.$store.dispatch('getUiConfig');
                  vm.$emit("success");

                  var nextView = vm.findDefaultView(userData);
                  if(nextView == null){
                    vm.showError = true;
                    vm.errorMsg = vm.$t("login_view.no_rights");
                    return;
                  }

                  //console.log(resp.data)

                  /* Jos komponentti on modalissa niin ei ohjata käyttäjää muualle vaan emitoidaan vain success */
                  if(!vm.$props.modal) {
                    
                    try {
                      var redirect = vm.$router.currentRoute.query.redirect;
                      if(redirect && redirect.length > 1) {
                          vm.$router.push(vm.$router.currentRoute.query.redirect, ()=>{}, ()=>{
                            setTimeout(function(){
                              vm.loader = false;
                              vm.errorMsg = vm.$t("login_view.no_right_to_path");
                              vm.showError = true;
                            }, 1000);
                          });
                        }
                        else {
                          vm.$router.push(nextView);
                        }
                    } catch(error) {
                      vm.$router.push('/');              
                    }
                    } else {
                       vm.$router.push(nextView);
                    }
                  }
              }, 1000);
            
           })
           .catch(error => {
              setTimeout(function(){
                vm.loader = false;
                vm.errorMsg = error;                
                vm.showError = true;
              }, 1000);
          }
        );
    },
    findDefaultView(userData){
        //takes from UI rights only the path part, excluding imprecise occurrences such as /content without further path
        let userRightList = userData.userPreferences.userRightList
          .filter(right => right.includes("[UI]")).map(right => right
          .split(' ')[1])
          .filter(right => (right.match(/\//g) || []).length >= 2); //it takes occurences like /content/images but no /content

        //if user doesn't have any right return null
        if(userRightList == null || userRightList.length <= 0)
          return null;
      
        //return defaultView if it is in userRightList
        let defaultView = userData.userPreferences.defaultView;
        if(defaultView != null && userRightList.includes(defaultView))
          return defaultView;

        //return some view from predefined default views if some of them is in userRightList
        defaultView = this.defaultViews.find(view => userRightList.includes(view));
        if(defaultView != null)
          return defaultView;

        //return alphabeticaly first view from userRight list
        return userRightList.sort()[0];
    }
   }
  
}
</script>




